"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOS = exports.EDITOR = exports.MANAGE = exports.CHECKOUT = exports.HELP = exports.CREATION = void 0;
var CREATION = 'creation';
exports.CREATION = CREATION;
var HELP = 'help';
exports.HELP = HELP;
var CHECKOUT = 'checkout';
exports.CHECKOUT = CHECKOUT;
var MANAGE = 'manage';
exports.MANAGE = MANAGE;
var EDITOR = 'editor';
exports.EDITOR = EDITOR;
var FOS = 'fos';
exports.FOS = FOS;